import { System } from '@ecs/System';
import { WeaponRangeDisplay } from '@components/WeaponRangeDisplay';
import { StandardWeapon } from '@components/StandardWeapon';
import { RailgunWeapon } from '@components/RailgunWeapon';
import { Tag } from '@components/Tag';
import { PlayerInput } from '@components/PlayerInput';

export class WeaponRangeLogicSystem extends System {
  update(_deltaTime: number): void {
    // Update weapon range display for all entities
    const entities = this.getEntitiesWithComponents(WeaponRangeDisplay);
    
    for (const entity of entities) {
      const rangeDisplay = entity.getComponent(WeaponRangeDisplay)!;
      const tag = entity.getComponent(Tag);
      
      // Reset display state
      rangeDisplay.showRange = false;
      rangeDisplay.range = 0;
      
      // Check if this is a player with manual mode
      if (tag?.value === 'player') {
        const standardWeapon = entity.getComponent(StandardWeapon);
        const playerInput = entity.getComponent(PlayerInput);
        
        if (standardWeapon && standardWeapon.mode === 'manual' && playerInput?.targetPosition) {
          rangeDisplay.showRange = true;
          rangeDisplay.range = standardWeapon.range;
          rangeDisplay.rangeColor = 'rgba(0, 200, 255, 0.15)';
          rangeDisplay.rangeStrokeColor = 'rgba(0, 200, 255, 0.3)';
        }
      }
      
      // Check if this is an enemy with railgun
      if (tag?.value === 'enemy') {
        const railgun = entity.getComponent(RailgunWeapon);
        
        if (railgun) {
          rangeDisplay.showRange = true;
          rangeDisplay.range = railgun.range;
          rangeDisplay.rangeColor = 'rgba(255, 0, 255, 0.1)';
          rangeDisplay.rangeStrokeColor = 'rgba(255, 0, 255, 0.3)';
        }
      }
    }
  }
}